<template>
  <div v-if="this.a.A_NOM_DE !== null && this.a.A_NOM_DE !== undefined">
    <wizard-steps
      :current-step="3"
      :show-third-step="a.A_NOM_DE === 1"
      :show-single-title="page === 6"
    ></wizard-steps>
    <div class="alert-form-container">
      <b-row align-v="end">
        <b-col cols="12" md="3" v-if="a.A_NOM_DE === 1">
          <b-form-group
            :state="vNombreInfoAlerta()"
            :invalid-feedback="fb.NOMBRE_INFO_ALERTA"
            label="Nombre"
            label-for="NOMBRE_INFO_ALERTA"
            :class="{ required: a.QUIEN_INFORMA === 'Ciudadano' && !alertaAnonima }"
          >
            <b-form-input
              :state="vNombreInfoAlerta()"
              v-model="a.NOMBRE_INFO_ALERTA"
              id="NOMBRE_INFO_ALERTA"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" v-if="a.A_NOM_DE === 1">
          <b-form-group
            :state="validateSurname()"
            :invalid-feedback="fb.APELLIDO_INFO_ALERTA"
            label="Apellido"
            label-for="APELLIDO_INFO_ALERTA"
          >
            <b-form-input
              :state="validateSurname()"
              v-model="a.APELLIDO_INFO_ALERTA"
              id="APELLIDO_INFO_ALERTA"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" v-if="a.A_NOM_DE === 1 && a.QUIEN_INFORMA === 'Ciudadano'">
          <b-form-group
            :state="vDocumentoInfoAlerta()"
            :invalid-feedback="fb.NDOCU_INFO_ALERTA"
            label="Número de documento"
            label-for="NDOCU_INFO_ALERTA"
          >
            <div class="row">
              <div class="col-4">
                <b-dropdown class="satmed-btn-dropdown">
                  <template #button-content>
                    {{ getTextById(a.TIPODOCU_INFO_ALERTA, 'tiposDocumentos', 'sigla') }}
                  </template>
                  <b-dropdown-item
                    v-for="(tipo, index) in tiposDocumentos"
                    @click="a.TIPODOCU_INFO_ALERTA = tipo.value"
                    :key="index"
                    class="satmed-input-style"
                  >
                    <div class="d-flex">
                      <div style="min-width: 55px">
                        <b>
                          {{ tipo.sigla }}
                        </b>
                      </div>
                      <div>- {{ tipo.text }}</div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="col-8">
                <b-form-input
                  placeholder="No."
                  :state="vDocumentoInfoAlerta()"
                  id="NDOCU_INFO_ALERTA"
                  v-model="a.NDOCU_INFO_ALERTA"
                  :disabled="!a.TIPODOCU_INFO_ALERTA"
                ></b-form-input>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" v-if="a.A_NOM_DE === 1 && a.QUIEN_INFORMA === 'Ciudadano'">
          <b-form-group
            :state="vGeneroInfoAlerta()"
            :invalid-feedback="fb.GENERO_INFO_ALERTA"
            label="Sexo"
            label-for="GENERO_INFO_ALERTA"
          >
            <b-form-select
              :state="vGeneroInfoAlerta()"
              :options="generos"
              v-model="a.GENERO_INFO_ALERTA"
              id="GENERO_INFO_ALERTA"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3" v-if="a.A_NOM_DE === 1 && a.QUIEN_INFORMA === 'Ciudadano'">
          <b-form-group
            :state="vEdadInfoAlerta()"
            :invalid-feedback="fb.EDAD_INFO_ALERTA"
            label="Edad"
            label-for="EDAD_INFO_ALERTA"
          >
            <b-form-input
              :state="vEdadInfoAlerta()"
              v-model="a.EDAD_INFO_ALERTA"
              id="EDAD_INFO_ALERTA"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :state="vNContactoInforma()"
            :invalid-feedback="fb.NCONTACTO_INFORMA"
            label="Teléfono"
            label-for="NCONTACTO_INFORMA"
            :class="{ required: !a.EMAIL_INFORMA && !alertaAnonima }"
          >
            <b-form-input
              :state="vNContactoInforma()"
              v-model="a.NCONTACTO_INFORMA"
              id="NCONTACTO_INFORMA"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :state="vEmailInforma()"
            :invalid-feedback="fb.EMAIL_INFORMA"
            label="Correo electrónico"
            label-for="EMAIL_INFORMA"
            :class="{ required: !a.NCONTACTO_INFORMA && !alertaAnonima }"
          >
            <b-form-input
              autocomplete="off"
              :state="vEmailInforma()"
              v-model="a.EMAIL_INFORMA"
              id="EMAIL_INFORMA"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label-for="alertaAnonima">
            <satmed-slider-checkbox id="alertaAnonima" v-model="alertaAnonima">
              Enviar la alerta de manera anónima
            </satmed-slider-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import { expresiones } from '@/assets/expresionesRegulares';
import WizardSteps from '@/components/UI/WizardSteps.vue';

export default {
  name: 'PaginaNombreDe',
  props: {
    page: Number,
  },
  data() {
    return {
      politica: false,
      alertaAnonima: false,
      comunaSelected: null,
      barrioSelected: null,
      /** @type {any} */
      fb: {},
      baseUrl: process.env.BASE_URL,
    };
  },
  components: {
    WizardSteps,
  },
  computed: {
    barriosFiltered() {
      const barrios = this.barrios.filter(
        (e) => e.COMUNA === String(this.comunaSelected) || e.value === null,
      );
      return barrios.sort((a, b) => {
        if (b.value === null) {
          return 1;
        }
        if (a.text > b.text) {
          return 1;
        }
        if (a.text < b.text) {
          return -1;
        }
        return 0;
      });
    },
    ...mapState({
      a: (state) => state.alerta.item,
    }),
    ...mapState('alerta', ['tiposDocumentos', 'generos', 'comunas', 'barrios']),
    ...mapGetters('alerta', ['getTextById']),
  },
  methods: {
    ...mapMutations('alerta', ['setPageValidate']),
    validatePage() {
      return (
        this.vNombreInfoAlerta()
        && this.validateSurname()
        && this.vDocumentoInfoAlerta()
        && this.vGeneroInfoAlerta()
        && this.vEdadInfoAlerta()
        && this.vEmailInforma()
        && this.vNContactoInforma()
      );
    },
    vNombreInfoAlerta() {
      if (this.a.A_NOM_DE === 0 || this.a.QUIEN_INFORMA !== 'Ciudadano') {
        return true;
      }
      if (this.a.NOMBRE_INFO_ALERTA === null) {
        return null;
      }
      if (this.a.NOMBRE_INFO_ALERTA === '') {
        this.fb.NOMBRE_INFO_ALERTA = 'No olvides indicar su nombre';
        return false;
      }
      if (!expresiones.alphanumeric.test(this.a.NOMBRE_INFO_ALERTA)) {
        this.fb.NOMBRE_INFO_ALERTA = 'Este campo solo permite caracteres alfanuméricos';
        return false;
      }

      if (this.a.NOMBRE_INFO_ALERTA.length > 100) {
        this.fb.NOMBRE_INFO_ALERTA = 'Por favor indique un nombre que no supere máximo 100 caracteres';
        return false;
      }

      return true;
    },
    validateSurname() {
      if (this.a.A_NOM_DE === 0) {
        return true;
      }
      if (this.alertaAnonima) {
        return true;
      }
      if (!this.a.APELLIDO_INFO_ALERTA) {
        return true;
      }
      if (!expresiones.alphanumeric.test(this.a.APELLIDO_INFO_ALERTA)) {
        this.fb.APELLIDO_INFO_ALERTA = 'Este campo solo permite caracteres alfanuméricos';
        return false;
      }

      if (this.a.APELLIDO_INFO_ALERTA.length > 100) {
        this.fb.APELLIDO_INFO_ALERTA = 'Por favor indique un apellido que no supere máximo 100 caracteres';
        return false;
      }

      return true;
    },
    vDocumentoInfoAlerta() {
      if (this.a.A_NOM_DE === 0 || this.a.QUIEN_INFORMA !== 'Ciudadano') {
        return true;
      }
      if (this.alertaAnonima) {
        return true;
      }
      if (this.a.A_NOM_DE !== 0 && !this.a.NDOCU_INFO_ALERTA) {
        return true;
      }
      if (!expresiones.numeric.test(this.a.NDOCU_INFO_ALERTA)) {
        this.fb.NDOCU_INFO_ALERTA = 'Este campo solo permite caracteres numéricos';
        return false;
      }

      if (this.a.NDOCU_INFO_ALERTA.length > 20) {
        this.fb.NDOCU_INFO_ALERTA = 'Por favor indique un número que no supere máximo 20 caracteres';
        return false;
      }

      return true;
    },
    vGeneroInfoAlerta() {
      return true;
    },
    vEdadInfoAlerta() {
      return true;
    },
    vEmailInforma() {
      if (this.alertaAnonima) {
        return true;
      }
      if (this.a.EMAIL_INFORMA === null && !this.a.NCONTACTO_INFORMA) {
        return null;
      }
      if (this.a.EMAIL_INFORMA === '' && !this.a.NCONTACTO_INFORMA) {
        this.fb.EMAIL_INFORMA = 'Este campo es obligatorio si no se agrega un teléfono';
        return false;
      }
      if (this.a.EMAIL_INFORMA && !expresiones.email.test(this.a.EMAIL_INFORMA)) {
        this.fb.EMAIL_INFORMA = 'Este campo solo permite caracteres alfanuméricos y un correo electrónico válido';
        return false;
      }
      if (this.a.EMAIL_INFORMA && this.a.EMAIL_INFORMA.length > 150) {
        this.fb.EMAIL_INFORMA = 'Por favor indique un correo electrónico que no supere máximo 150 caracteres';
        return false;
      }
      return true;
    },
    vNContactoInforma() {
      if (this.alertaAnonima) {
        return true;
      }
      if (this.a.EMAIL_INFORMA === null && !this.a.NCONTACTO_INFORMA) {
        return null;
      }
      if (this.a.EMAIL_INFORMA === '' && !this.a.NCONTACTO_INFORMA) {
        this.fb.NCONTACTO_INFORMA = 'Este campo es obligatorio si no se agrega un correo';
        return false;
      }
      if (!expresiones.numeric.test(this.a.NCONTACTO_INFORMA)) {
        this.fb.NCONTACTO_INFORMA = 'Este campo solo permite caracteres numéricos';
        return false;
      }
      if (this.a.NCONTACTO_INFORMA.length > 10) {
        this.fb.NCONTACTO_INFORMA = 'Por favor indique un número que no supere máximo 10 caracteres';
        return false;
      }
      return true;
    },
  },
  watch: {
    a: {
      deep: true,
      handler() {
        this.setPageValidate({ page: this.page, state: this.validatePage() });
        this.comunaSelected = this.a.COMUNA_ID;
        this.barrioSelected = this.a.BARRIO_ID;
        if (this.a.id) {
          this.politica = true;
        }
      },
    },
    comunaSelected() {
      this.a.COMUNA_ID = this.comunaSelected;
      this.a.COMUNA_NAME = this.getTextById(this.comunaSelected, 'comunas', 'text');
      this.barrioSelected = null;
      this.a.BARRIO_ID = null;
      this.a.BARRIO_NAME = this.getTextById(this.barrioSelected, 'barrios', 'text');
    },
    barrioSelected() {
      this.a.BARRIO_ID = this.barrioSelected;
      this.a.BARRIO_NAME = this.getTextById(this.barrioSelected, 'barrios', 'text');
    },
    alertaAnonima() {
      if (this.alertaAnonima) {
        this.a.NOMBRE_INFO_ALERTA = 'ANONIMO';
      } else {
        this.a.NOMBRE_INFO_ALERTA = null;
      }
    },
  },
  // mounted() {
  //   const [name, surname] = this.a.NOMBRE_INFO_ALERTA.split(',');
  //   this.a.NOMBRE_INFO_ALERTA = name;
  //   this.a.APELLIDO_INFO_ALERTA = surname || null;
  // },
};
</script>

<style scoped></style>
